module.exports = __webpack_public_path__ + "img/12.d137329c.png";